module.exports = __webpack_public_path__ + "static/office2-d57fa885fa5c7002dc43e9dd61172af7.jpg";